import{useEffect}from"react";import{useLogout}from"Components/User/Hooks";export default(()=>{const logout=useLogout();useEffect(()=>{logout()});return null});